import ILanguagePackage from "../ILanguagePackage";

const Ukrainian: ILanguagePackage = {
    name: 'Українська',
    header: "Керівництво Користувача",
    content: [
        {
            heading: "Загальні відомості",
            id: 'general-info',
            content: [
                {
                    type: 'text',
                    content:
                        "Дана система є розширенням інструменту [[lnk]], створеним аби допомогти тестувальникам, "+
                        "розробникам та іншим учасникам процесу скрепінгу у вирішенні їх повсякденних задач. Основною "+
                        "функцією ValidationRuler є пошук унікальних фраз та атрибутів, притаманних документам того чи "+
                        "іншого типу для конкретної категорії продуктів. Окрім цього, застосунок надає можливість порівнювати "+
                        "дані excel-таблиці з її попередніми снепшотами (або ж порівняти два снепшоти), що може бути корисним "+
                        "при проведення повторних тестувань. Цей же інструмент дозволяє переглянути дані excel-таблиці, якщо "+
                        "вона не відкривається у VIPER через надвеликий розмір даних.",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'text',
                    content:
                        "З виявлення нових викликів функціонал системи і надалі розширюватиметься. Повний перелік "+
                        "поточних можливостей можна побачити у [[lnk]], яке зображено на рисунку 1. Потрапити на "+
                        "нього може будь-який авторизований користувач, натиснувши на назву 'Validation Ruler' у верхньому "+
                        "лівому куті кожного екрану. Детальніше про функціонал буде розписано у наступних розділах.",
                    links: [{title: "головному меню", href: "https://validationrulerapp.web.app/"}]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 1,
                        src: '/manual/main_menu.png',
                        description: "Головне меню та (виділеним) основний спосіб на ного потрапити."
                    }
                },

            ]
        },
        {
            heading: "Авторизація",
            id: 'authorization',
            content: [
                {
                    type: 'text',
                    content:
                        "Для доступу до функціоналу системи необхідно авторизуватися. Для цього використовуються креденціали, "+
                        "надані [[lnk]]. Для зручності прийнято використовувати дані для входу у [[lnk]], у такому випадку "+
                        "токен доступу dfs згенерується автоматично. Колистувач лишається авторизованим, доки не вийде з "+
                        "акаунту вручну з допомогою кнопки у верхньому правому куту кожної сторінки, або не досягне періоду "+
                        "неактивності у 7 днів.",
                    links: [
                        {title: "адміністратором", href: "https://t.me/wanna_be_a_cat_bot"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "VIPER", href: "https://dataforspec.com/"}
                    ]
                },
                {
                    type: 'text',
                    content:
                        "Якщо користувач попросив [[lnk]] зареєструвати його на інші дані для входу, відмінні від "+
                        "використовуваних у [[lnk]] - при першому вході система також вимагатиме ввести VIPER access "+
                        "token. Знайти його можна в Authorization хедері будь-якого запиту на [[lnk]], як показано на "+
                        "рисунку 3. Для цього необхідно перебуваючи на будь-якій його сторінці та будучи авторизованим, "+
                        "відкрити консоль розробника (у більшості браузерів - натиснувши F12), знайти а відкрити вкладку "+
                        "Network, оновити сторінку, та у списку запитів знайти один документного типу і натиснути на нього, "+
                        "як показано на рисунку 2.",
                    links: [
                        {title: "адміністратора", href: "https://t.me/wanna_be_a_cat_bot"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 2,
                        src: '/manual/dev_console_1.png',
                        description: "Вкладка Network консолі розробника та документний запит."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Після обрання необхідного запиту потрібно відкрити вкладку Headers (зазвичай відкривається за "+
                        "замовчуванням), знайти розділ Request Headers, відшукати у ньому рядок із заголовком "+
                        "Authorization та скопіювати його значення (без слова Basic!), як показано на рисунку 3. Отриманий токен потрібно ввести "+
                        "у відповідне поле системи ValidationRuler.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 3,
                        src: '/manual/dfs_token.png',
                        description: "Пошук хедера авторизації та отримання VIPER токена."
                    }
                },
            ]
        },
        {
            heading: "Створення акаунту",
            id: 'sign-up',
            content: [
                {
                    type: 'text',
                    content:
                        "Якщо користувач має акаунт у [[lnk]], але все ще не має доступу до системи ValidationRuler - "+
                        "він може або звернутися до одного з адміністраторів, або ж зареєструватися самостійно з "+
                        "використанням VIPER токену, отримання якого детально описано у [[lnk]]. Для цього необхідно на "+
                        "сторінці входу натиснути на напис 'or Sign Up' під кнопкою входу, після чого ввести VIPER токен "+
                        "у спливаючому вікні. Після цього користувач або отримає повідомлення з помилкою, або ж зможе "+
                        "увійти в систему за своїми креденціалами [[lnk]].",
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "попередньому розділі", href: "#authorization"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
            ]
        },
        {
            heading: "Пошук ключових слів та фраз",
            id: 'rules-search',
            content: [
                {
                    type: 'text',
                    content:
                        "Сторінка категорій поділена на кілька частин. Зліва розташований список категорій користувача, "+
                        "де можна створити нову категорію, а також обрати для перегляну дэталей чи видалити існуючу. "+
                        "Центральна частина сторінки - робоча область, де відображаються деталі категорії та можливі дії "+
                        "з нею. Базова сторінка категорій зображена на рисунку 4.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 4,
                        src: '/manual/cat_screen.png',
                        description: "Сторінка категорій. Одну категорію створено, але не відкрито."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Після обрання категорії зі списку вона з'являється у робочій області. Зверху розташована картка "+
                        "з основними відомостями:",
                },
                {
                    type: 'u-list',
                    content:
                        ["Номер категорії", "Виробник", "Назва категорії", "Дата створення", "Статус"],
                },
                {
                    type: 'text',
                    content:
                        "Нижче розташовується 5 кнопок: ",
                },
                {
                    type: 'u-list',
                    content: [
                        "'Perform 1 step' - намагається виконати необхідні дії для переведення категорії у наступний "+
                        "статус. Кожен такий крок може займати від кількох секунд до 40 хвилин, залежно від розміру "+
                        "категорії та складності операції.",

                        "'Perform all steps' - aби весь час не моніторити сторінку для запуску наступної стадії обробки, "+
                        "змушує категорію пройти усі стадії одразу і досягти або кінцевого стану (Attributes_Found), "+
                        "або ж помилки, якщо така трапиться у процесі обробки.",

                        "'Reload category' - дозволяє заново завантажити таблицю з [[lnk]] та, за бажання, ще раз "+
                        "проробити усі операції.",

                        "'View Excel' - переадресовує Вас на сторінку [[lnk]] для цієї категорії.",

                        "'View PVR' - переадресовує Вас на сторінку [[lnk]] для цієї категорії."
                    ],
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "перегляду Excel-таблиці", href: "/user-guide#excel-diff"},
                        {title: "перегляду PVR", href: "/user-guide#pvr"},
                    ]
                },
                {
                    type: 'text',
                    content: "Кнопка 'Reload Category' недоступна коли категорію тільки створено, а дві інші - коли "+
                        "категорія досягла кінцевого стану. Сторінку з деталями категорії зображено на рисунку 5.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 5,
                        src: '/manual/cat_details.png',
                        description: "Сторінка з деталями категорії."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Після того, як система виконає усі необхідні операції для пошуку ключових слів та атрибутів - "+
                        "отримані результати з'являться на сторінці. Користувач зможе перемикатися між вкладками "+
                        "документів та переглядати ключові фрази або атрибути, на його вибір. Що одні, що інші "+
                        "міститимуть інформацію про документи, у яких їх було знайдено, а в яких ні. Сторінку з отриманими "+
                        "результатами зображено на рисунку 6.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 6,
                        src: '/manual/cat_results.png',
                        description: "Сторінка з результатами пошуку фраз та атрибутів."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Також знизу сторінки з'являється поле, яке дозволяє користувачу виконати аналіз для певної "+
                        "конкретної фрази і перевірити, в яких документах вона зустрічається. Отримавши результати "+
                        "такого аналізу, користувач може перемикатися між вкладками документів, аби пересвідчитися, що "+
                        "фраза є унікальною для певного типу. Результат такого пошуку зображено на рисунку 7.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 7,
                        src: '/manual/custom_phrase_test.png',
                        description: "Сторінка з результатами аналізу фрази."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Наразі це весь доступний функціонал з цієї області. Надалі він покращуватимуться і "+
                        "розширюватиметься, як тільки з'являтимуться нові вимоги чи ідеї.",
                },
            ]
        },
        {
            heading: "Порівняння снепшотів таблиць",
            id: 'excel-diff',
            content: [
                {
                    type: 'text',
                    content:
                        "Під час скрепінгу не варто забувати одну особливість даної галузі: дані часто змінюються. І "+
                        "візуально відслідкувати такі зміни може бути непросто, або ж і нереально. На щастя, [[lnk]] "+
                        "надає інструменти для порівняння з даними у БД. Але що робити, якщо виникає потреба виконати порівняння "+
                        "з ранішою версією даних, яка ще не в релізі?",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'text',
                    content:
                        "Саме для таких цілей ValidationRuler надає функціонал порівняння даних двох снепшотів таблиці. "+
                        "Все, що для цього потрібно - це ввести їх номер категорії та час створення (параметр dt посилання "+
                        "на снепшот). Якщо необхідно порівняти дані актуальної таблиці - перший із dt можна лишити незаповненим.",
                },
                {
                    type: 'text',
                    content:
                        "Для того, аби знайти знімок даних за певну дату, необхідно на сторінці категорії у [[lnk]] "+
                        "натиснути на кнопку 'HISTORY' у правому верхньому куті екрану (рисунок 8). В отриманій таблиці "+
                        "обрати рядок із текстом 'New Excel file loaded' за бажану дату і натиснути на кнопку 'View Excel' "+
                        "поруч із ним (рисунок 9). На отриманій сторінці у рядку адреси можна знайти параметр dt, який "+
                        "нам, власне, і потрібен (рисунок 10).",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 8,
                        src: '/manual/history_location.png',
                        description: "Місцезнаходження кнопки 'HISTORY'."
                    }
                },
                {
                    type: 'image',
                    content: {
                        imgId: 9,
                        src: '/manual/snapshot_location.png',
                        description: "Пошук необхідного знімку даних."
                    }
                },
                {
                    type: 'image',
                    content: {
                        imgId: 10,
                        src: '/manual/dt_location.png',
                        description: "Місцезнаходження параметру dt."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Після введення необхідних параметрів та натискання кнопки 'Compare' розпочнеться процес "+
                        "завантаження та порівняння таблиць, який може тривати до 5 хвилин. По закінченню обробки "+
                        "користувач отримає таблицю змін, як на рисунку 11. У ній колір колонки (червоний або зелений) "+
                        "означає, що такий атрибут раніше був присутнім, а тепер зник, або ж навпаки, лише з'явився. У "+
                        "свою чергу, рядки теж можуть мати різний колір залежно він свого статусу. Незмінені матимуть "+
                        "колір фону. Нові стануть зеленими, зниклі - червоними, а частково змінені у несуттєвих колонках"+
                        " - синіми. Несуттєвими вважаються колонки документів, зображень та посилань, а також будь-які "+
                        "інші, якщо вони позначені як нові чи зниклі. При чому, якщо можливо визначити, на основі значення "+
                        "якої клітинки рядок набув того чи іншого статусу - таку клітинку буде виділено трохи яскравішим "+
                        "кольором. Виняток становлять модифіковані (сині) рядки, у яких один з атрибутів з'явився чи зник "+
                        "через додавання або зникнення цілої колонки. Для них значення у цих колонках (уже кольорові) не "+
                        "виділятимуться яскравішим кольором додатково.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 11,
                        src: '/manual/cmp_result.png',
                        description: "Результат порівняння актуальної таблиці категорії 432 зі старішим знімком."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Ви також можете посилатися на знімок за його індексом, без використання часової мітки з історії. "+
                        "У такому випадку використовується від'ємний індекс. Як уже згадувалося, для отримання найновішого "+
                        "знімку можна лишити поле порожнім, для передостаннього використаємо індекс -1, для "+
                        "перед-передостаннього - індекс -2, і т.д. ",
                    links: []
                },
                {
                    type: 'text',
                    content:
                        "У верхньому правому куті сторінки знаходиться 4 різнокольорових прапорці. Вмикаючи "+
                        "або вимикаючи їх, можна обрати, рядки з яким статусом Ви хочете переглядати. Наприклад, якщо "+
                        "Вам потрібні лише видалені рядки - вимкніть усі прапорці, окрім червоного.",
                    links: []
                },
                {
                    type: 'text',
                    content:
                        "Також даний інструмент дозволяє просто переглянути поточну таблицю (або будь-який снепшот). "+
                        "Для цього потрібно лишити обидва поля незаповненими (або ж заповнити їх однаковими значеннями "+
                        "dt чи індексів). Це може бути корисним у випадках, коли таблиця не відкривається у [[lnk]] через завеликий "+
                        "розмір. Validation Ruler краще оптимізований, тому дозволяє без проблем відкривати таблиці навіть на "+
                        "60'000 рядків, а можливо і більше, наразі просто не було можливості це перевірити.",
                    links: [{title: "VIPER", href: "https://dataforspec.com/"}]
                },
            ]
        },
        {
            heading: "Перегляд PVR",
            id: 'pvr',
            content: [
                {
                    type: 'text',
                    content:
                        "Ще одна проблема, з якою можуть стикнутися користувачі [[lnk]] - проблеми із завантаженням PVR "+
                        "через брак оперативної пам'яті. Саме для таких випадків ValidationRuler надає можливість "+
                        "переглядати даний звіт у більш оптимізований спосіб. Для цього необхідно у головному меню обрати "+
                        "опцію [[lnk]], ввести у поле номер категорії та натиснути кнопку 'Load PVR'. Після завантаження "+
                        "даних користувач зможе обрати тип файлів, для яких він хоче переглянути знайдені проблеми. У табличці "+
                        "буде відображений вміст аналогічний тому, що і на оригінальній сторінці [[lnk]], як показано на рисунку 12.",
                    links: [
                        {title: "VIPER", href: "https://dataforspec.com/"},
                        {title: "'PVR Documents'", href: "/pvr"},
                        {title: "VIPER", href: "https://dataforspec.com/"},
                    ]
                },
                {
                    type: 'image',
                    content: {
                        imgId: 12,
                        src: '/manual/cat_pvr.png',
                        description: "Вигляд сторінки з PVR для категорії 239."
                    }
                },
                {
                    type: 'text',
                    content:
                        "Варто зауважити, що на даній сторінці будуть відображені лише проблеми з файлами різний типів. "+
                        "Пропущені значення інших колонок можна відслідкувати, відфільтрувавши у перегляді Excel-таблиці "+
                        "значення по 'MISSING'.",
                },
            ]
        },
        {
            heading: "Перевірка на перетини категорій",
            id: 'healthcheck',
            content: [
                {
                    type: 'text',
                    content:
                        "Документацію до даного функціоналу українською ще не створено. Вона доступна лише в англійській "+
                        "версії. Перепрошуємо за тимчасові незручності.",
                    links: []
                },
                // {
                //     type: 'text',
                //     content:
                //         "Sometimes filters on manufacturers' websites work in such a way that the same products fall "+
                //         "into several categories at once. Such duplication would be critical for [[lnk]] system. However, "+
                //         "this problem is practically impossible to catch manually. That is why the functionality "+
                //         "for searching for category intersections was developed.",
                //     links: [
                //         {title: "SpecID", href: "https://project.spec-id.com/products/advancedSearch"},
                //     ]
                // },
                // {
                //     type: 'text',
                //     content:
                //         "The flow is pretty easy and straightforward. You just need to select the manufacturer from the "+
                //         "list, as shown on the Figure 13, and press the 'Analyze' button. The system will try to load the "+
                //         "previous check result if such exists or generate a new report. This can take a very long time, up "+
                //         "to an hour, depending on the number of categories and their sizes. The system checks if there are "+
                //         "some rows with the same URL, name, Size and (optionally) Shape common for different categories. "+
                //         "A row with not specified Shape is considered a duplicate of rows with Shape if the other "+
                //         "attributes match. Sometimes in the intersection report you may see several rows that look the "+
                //         "same. But they actually have different URLs, and that's why each of them is included into the "+
                //         "table. The result of such checks is shown on the Figure 14.",
                //     links: []
                // },
                // {
                //     type: 'image',
                //     content: {
                //         imgId: 13,
                //         src: '/manual/intersections_manufacturer_selection.png',
                //         description: "The list of available manufacturers."
                //     }
                // },
                // {
                //     type: 'image',
                //     content: {
                //         imgId: 14,
                //         src: '/manual/intersections_result.png',
                //         description: "Intersections report for Gerflor manufacturers. A lot of intersections found, some of them look the same but have different URLs."
                //     }
                // },
                // {
                //     type: 'text',
                //     content:
                //         "You can always re-analyze the manufacturer and load the fresh report by pressing the "+
                //         "'Rerun analysis' button. The second button ('Show cat sizes') allows us to check the number of "+
                //         "categories and their sizes. It may be useful for product managers.",
                // },
            ]
        },
        {
            heading: "Керування користувачами (для адміністраторів)",
            id: 'users-management',
            content: [
                {
                    type: 'text',
                    content:
                        "Документацію до даного функціоналу українською ще не створено. Вона доступна лише в англійській "+
                        "версії. Перепрошуємо за тимчасові незручності.",
                },
                // {
                //     type: 'text',
                //     content:
                //         "If you are an admin, there is a 'Manage Users' tab in the main menu. It's page contains a left "+
                //         "sidebar with a list of all users and a main area with selected user's details and available actions. "+
                //         "Initially, this page was also planned to allow viewing of the user's recent actions, but this "+
                //         "functionality was later rejected as unnecessary. The user management page is shown in Figure 15.",
                // },
                // {
                //     type: 'image',
                //     content: {
                //         imgId: 15,
                //         src: '/manual/user_management.png',
                //         description: "User management page."
                //     }
                // },
                // {
                //     type: 'text',
                //     content:
                //         "Here you can create new user account by clicking the button in the lower left corner of the "+
                //         "page and entering the credentials (it is recommended to use [[lnk]]'s credentials for better "+
                //         "integration). You can also remove users if they are lower than you in access rights, promote "+
                //         "regular users to administrators, and superadmins can also demote administrators back to regular "+
                //         "users or create new superadmins.",
                //     links: [
                //         {title: "VIPER", href: "https://dataforspec.com/"},
                //     ]
                // },
            ]
        },
        {
            heading: "Логування",
            id: 'logs',
            content: [
                {
                    type: 'text',
                    content:
                        "У кожній системі час від часу виникають різноманітні проблеми. І важливо мати можливість це "+
                        "відслідковувати. Саме для цього у головному меню існує спеціальна сторінка для перегляду логів. "+
                        "На ній угорі екрану розміщено панель для вибору рівня логу, а також форма для вибору максимальної "+
                        "кількості відображуваних рядків. По замовчуванню дані беруться із найбільш свіжих файлів, проте "+
                        "спеціальний чекбокс дозволяє включити також і старіші дані, якщо у цьому є потреба. На рисунку "+
                        "16 зображено сторінку перегляну логів рівня INFO.",
                },
                {
                    type: 'image',
                    content: {
                        imgId: 16,
                        src: '/manual/logs.png',
                        description: "Сторінка перегляду логів."
                    }
                },
            ]
        },
        {
            heading: "Додаткові відомості",
            id: 'additional',
            content: [
                {
                    type: 'text',
                    content:
                        "Наступні кроки у розвитку проекту:",
                },
                {
                    type: 'o-list',
                    content: [
                        "Додавання нового типу кнопок, окрім уже існуючих важливих дій та деструктивних дій - інформаційні кнопки, "+
                        "скоріше за все, синього або сірого кольору, для логічного розділення різних типів дій;",

                        "Винесення панелі керування користувачами на окрему сторінку, додавання функції перегляду "+
                        "категорій користувача та керування ними (видалення);",

                        "Додавання піктограм до кнопок, які могли би замінити текст при малих розмірах екрану;",

                        "Зміна дизайну на адаптивний, аби дозволити користувачам зручно працювати із будь-якого пристрою.",
                    ],
                },
                {
                    type: 'text',
                    content:
                        "Наразі це вся важлива інформація про систему. Більше відомостей можна знайти [[lnk]].",
                    links: [{title: "за посиланням", href: "https://www.youtube.com/watch?v=dQw4w9WgXcQ"}]
                },
            ]
        },
    ],
    additional: {
        tableOfContents: "Зміст",
        picture: "Рисунок"
    },
}

export default Ukrainian;